module.exports = __webpack_public_path__ + "img/selection_arrow_hover.97e5524a.svg";